$(document).ready(function() {
    $('#fixe').on('keydown', e => addSpace(e, 2));
    $('#portable').on('keydown', e => addSpace(e, 2));
    $('#siren').on('keydown', e => addSpace(e, 3));
    $('#siren').on('paste', formatPaste);
});

//Add space between group of numbers define by the limit param
function addSpace(e, limit) {
    let len = e.target.value.length;
    if (e.key == ' ' && e.target.value.slice(-1) == ' ')
    {
        e.target.value = e.target.value.substr(0, len - 1);
        len -= 1;
    }
    if (((limit == 2 && len > 1 && len < 14)
        || (limit == 3 && len > 1 && len < 11))
        && e.key !== 'Backspace' && (len + 1) % (limit + 1) == 0)
            e.target.value += ' ';
}

//Adding trailing spaces on paste 
function formatPaste(e) {
    e.preventDefault();
    let paste = (e.clipboardData || window.clipboardData
        || e.originalEvent.clipboardData).getData('text');
    paste = paste.replace(/ /g, '');
    paste = `${paste.slice(0,3)} ${paste.slice(3, 6)} ${paste.slice(6)}`;
    e.target.value = paste;
}